import { FC, Fragment } from "react";
import { i18n } from "../../translate/i18n";
import { OrderType } from "../Datatable/Datatable";



type TableFooterProps = {
  copyData: any[];
  data: any[];
  indexPagination: number;
  perView: number;
  meta?: any;
  setIndexPagination: (value: number) => void;
  color?: string;
  pagination: any[];
  list: number[];
  stateSort:any;

  query:string;
  alterDataPerPage:  (take: number, page: number, search: string, order?: OrderType) => Promise<any>;
}

const TableFooter :FC<TableFooterProps> = ({
  copyData,
  data,
  perView,
  indexPagination,
  meta,
  setIndexPagination,
  color,
  pagination,
  list,
  alterDataPerPage,
  query,
  stateSort
}) => {

  return (
    <>
     {copyData && data && copyData.length > 0 && (
            <div className='py-3 d-flex justify-content-between text-xs h-100 w-100 text-gray-500 text-uppercase'>
              <span className='d-flex justify-content-between align-items-center col-6'>
                {i18n.t(`general.showing`)} {i18n.t(`general.of`)}{' '}
                {indexPagination === 0 ? 1 : indexPagination * perView} {i18n.t(`general.to`)}
                {` ${indexPagination * Number(perView) + copyData.length} `}
                {i18n.t(`general.of`)}
                {meta ? ` ${meta.itemCount} ` : data ? ` ${data.length} ` : ` ${0} `}{' '}
                {i18n.t(`general.records`)}
              </span>

              <span className='d-flex col-4 justify-content-end'>
                <nav aria-label='Table navigation'>
                  <ul className='d-flex inline-flex align-items-center m-0 list-unstyled'>
                    <li>
                      {((meta && meta.hasPreviousPage) || indexPagination > 0) && (
                        <button
                          className={`px-3 py-1 rounded border-0 bg-transparent text-hover-${color}`}
                          aria-label='Previous'
                          onClick={async () => {
                            setIndexPagination(indexPagination - 1)
                            await alterDataPerPage(
                              perView,
                              (meta && meta.page && parseInt(meta.page.toString()) - 1) || 1,
                              query,
                              stateSort
                            )
                          }}
                        >
                          <i className='fas fa-chevron-left ms-3'></i>
                        </button>
                      )}
                    </li>

                    {list.map((position: number) => (
                      <Fragment key={position}>
                        {position - 1 == indexPagination ? (
                          <button
                            className={`px-3 py-1 text-white transition-colors duration-150 bg-${color} border-0 rounded`}
                          >
                            {position}
                          </button>
                        ) : (
                          <>
                            {position - 1 <= indexPagination + 3 && position > indexPagination - 1 && (
                              <button
                                onClick={async () => {
                                  setIndexPagination(position - 1)
                                  await alterDataPerPage(perView, position, query, stateSort)
                                }}
                                className={`px-3 py-1 rounded border-0 bg-transparent`}
                              >
                                {position}
                              </button>
                            )}
                          </>
                        )}
                      </Fragment>
                    ))}

                    <li>
                      {((meta && meta.hasNextPage) || (indexPagination + 1)  < pagination.length - 1) && (
                        <button
                          className={`px-3 py-1 rounded border-0 bg-transparent text-hover-${color}`}
                          aria-label='Next'
                          onClick={async () => {
                            setIndexPagination(indexPagination + 1)
                            await alterDataPerPage(
                              perView,
                              (meta && meta.page && parseInt(meta.page.toString()) + 1) || 1,
                              query,
                              stateSort
                            )
                          }}
                        >
                          <i className='fas fa-chevron-right ms-3'></i>
                        </button>
                      )}
                    </li>
                  </ul>
                </nav>
              </span>
            </div>
          )}
    </>
  )
}

export {TableFooter}